import { useMemo } from 'preact/compat'
import { Container, Transition } from 'semantic-ui-react'
import { Text } from 'preact-i18n'
import { BarcodeMenuOptionsOverlayContainer, Link, Switch } from '../../atoms'
import { SymbologyOption, SymbologyOptionExtension } from '../../../store/SymbologyOption'

import { useStore } from '../../../store'
import modeSymbologies from '../../../store/modeSymbologies'

import SymbologiesOptionGrid from './SymbologiesOptionGrid'

const ExtendSymbolsSwitch = () => {
  const store = useStore()
  return (
    <Switch
      label={
        <label htmlFor="extendSymbolsCounts">
          <Text id="options.extendSymbolsCounts" />
        </label>
      }
      id="extendSymbolsCounts"
      checked={store.settingsStore.extendedSymbolCount.value}
      onChange={(_e, data) => store.settingsStore.setExtendSymbolsCount(data.checked ?? false).apply()}
    />
  )
}

const BarcodeMenuOptionOverlay = ({
  open,
  symbologiesOptions,
  symbologiesOptionsAddon,
  toggleSymbology,
  toggleAddon,
}: {
  open: boolean
  symbologiesOptions: SymbologyOption[]
  symbologiesOptionsAddon?: SymbologyOptionExtension[]
  toggleSymbology: (symbologyOption: SymbologyOption) => void
  toggleAddon?: (symbologyOption: SymbologyOptionExtension) => void
}) => {
  const { oneD, twoD } = useMemo(() => {
    return symbologiesOptions.reduce(
      (acc, symbologyOption) => {
        if (modeSymbologies.oneD.includes(symbologyOption.symbology)) acc.oneD.push(symbologyOption)
        if (modeSymbologies.twoD.includes(symbologyOption.symbology)) acc.twoD.push(symbologyOption)
        return acc
      },
      { oneD: [] as SymbologyOption[], twoD: [] as SymbologyOption[] }
    )
  }, [symbologiesOptions])

  return (
    // @ts-ignore
    <Transition visible={open} animation="fade" duration={250}>
      <BarcodeMenuOptionsOverlayContainer>
        <SymbologiesOptionGrid
          title={
            <>
              1D <Text id={'barcode'} plural={2} />
            </>
          }
          symbologiesOptions={oneD}
          symbologiesOptionsAddon={symbologiesOptionsAddon}
          toggleSymbology={toggleSymbology}
          toggleAddon={toggleAddon}
        />
        <SymbologiesOptionGrid
          title={
            <>
              2D <Text id={'barcode'} plural={2} />
            </>
          }
          symbologiesOptions={twoD}
          toggleSymbology={toggleSymbology}
        />
        <br />
        <Container textAlign="center">
          <small>
            <i>
              <Text id="info.extendSymbolsCounts.message" />{' '}
              <Link href="https://docs.scandit.com/stable/c_api/symbologies.html" target="_blank" rel="noopener">
                <u>
                  <Text id="info.extendSymbolsCounts.documentationLinkText" />
                </u>
              </Link>
              . <Text id="info.extendSymbolsCounts.message2" />
              <br />
            </i>
          </small>
          <ExtendSymbolsSwitch />
        </Container>
      </BarcodeMenuOptionsOverlayContainer>
    </Transition>
  )
}

export default BarcodeMenuOptionOverlay
